import React, { useState, useEffect } from "react";
import { Grid, CircularProgress, Typography, Button } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from '@material-ui/icons/Cancel';
import { cyanA700, grey300 } from "material-ui/styles/colors";
import { autoPayServices } from "./model/autopay-services";
import { v4 as uuid } from 'uuid'
import { store } from "../../../helpers/store";
import { Alert } from "@material-ui/lab";
import AutoPayAccordionComponent from "./view/_autopay-accordion";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/admin.service";
import { Hidden } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import {cssuseStyles} from "../e_billing-style"


const useStyle = makeStyles((theme) => ({
  heading: {
    backgroundColor: theme.palette.ePrimary?.base,
    color: "white",
    padding: "1.5% 3%",
  },
  quaternaryColor: {
    color: theme.palette.ePrimary?.base,
  },
  redColorAlert: {
    color: theme.palette.eTertiary?.base + " !important",
    fontSize:"0.8rem"
  },
  greenColorAlert: {
    color: theme.palette.eSecondary?.base + " !important",
  },
  emptyLogText: {
    marginTop: "25px",
    marginLeft: "5px"
  },
  emptyLogTextMedium: {
    marginTop: "25px",
    paddingLeft: "13px",
  },
  newButtonStyle: {
    marginTop: 23,
    marginRight: 5,
    background: theme.palette.ePrimary?.base,
    color: theme.palette.whiteColor.main,
    borderRadius: "17px",
    '&:hover': {
      backgroundColor: theme.palette.ePrimary?.hover,
      boxShadow: 'none',
    },
  },
  accordionContainerStyling: {
    padding: "7px",
    borderWidth: "10px",
    BorderStyle: "solid",
    margin: "0px",
    "& .MuiExpansionPanelSummary-content.Mui-expanded": {
      marginTop: "0px",
      marginBottom: "0px",
      
    }
  },
  mobileAccordionContainerStyling: {
    borderColor: grey300,
    padding: "7px",
    marginTop: -20,
    borderWidth: "10px",
    BorderStyle: "solid",
    margin: "0px"
  },
  successMsgStyling: {
    padding: "5px",
    "& .MuiAlert-standardError":{
      backgroundColor: theme.palette.eWhite?.base + " ! important"
    },
    "& .MuiAlert-standardSuccess": {
      backgroundColor: theme.palette.eWhite?.base + " ! important"
    }
  },
  footerButtonContainer: {
    margin: '2% !important',
  },
  spinnerStyle: {
    color: "white !important"
  },
  circulorProgressStyling: {
    color: theme.palette.whiteColor.main + " !important"
  },
  cancelIconStyling: {
    textAlign: "end"
  },
  curserStyling: {
    cursor: "pointer"
  },
  cancelButtonStyling: {
    color: theme.palette.ePrimary?.base,
    fontSize: "0.75rem",
    textTransform: "none"
  },
  mainGrid: {
    flexFlow: "column",
    height: "100%"
  },
  contentGrid: {
    flexGrow: "1",
    overflowX: "hidden"
  },
  loadingButton:{
    marginTop:"5% !important"
  }
}))
export default function E_Autopay(props) {
  const customStyles = cssuseStyles();
  let AUTO_PAYMENT_SUCCESS_TEXT;
  let AUTO_PAYMENT_DELETE_WARNING_TEXT;
  let EMPTY_RECORD_LOG_MESSAGE;
  let CHOOSE_ACCOUNT_TEXT;
  let BANK_TEXT = "Bank";
  let CREDIT_CARD_TEXT = "Credit Card";
  let DEBIT_CARD_TEXT = "Debit Card";
  let AUTOPAY_SINGLE_RECORD_DELETE_TEXT;
  let VALIDATION_CONTENTS = {}
  let AutopayTab = useSelector((state)=>state?.labels?.data?.getLabels?.E_AUTO_PAYMENT?.E_AUTOPAY_TAB_TITLE);
  const { onClickAutoPay } = props;
  const [autoPayData, setAutoPayData] = useState([])
  const [initialData, setInitialData] = useState()
  const [sourceList, setSourceList] = useState([])
  const [content, setContent] = useState();
  const [disable, setDisable] = useState(true)
  const [dataLoading, setDataLoading] = useState()
  const [showText, setShowText] = useState()
  const [isError, setIsError] = useState()
  const [showAlert, setAlert] = useState(false)
  const [loading, setLoading] = useState()
  const [isNew, setIsNew] = useState(false)
  const [onReset, setOnReset] = useState(false)
  const [enteredData, setEnteredData] = useState()
  const [emptyRecord, setEmptyRecord] = useState({
    startDate: null,
    endDate: null,
    autoPayMethod: '',
    externalAccountId: '',
    expireDate: '',
    entityName: '',
    autopayMaxWithdrawalAmount: '',
    comments: '',
    autopaySource: '',
    uuid: uuid()
  })
  const [row, setRow] = useState(null)
  const languageCode = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.E_AUTO_PAYMENT);
  const classes = useStyle();
  const accountId = store.getState().meterDetails?.accountId;

  const MAX_LIMIT_TENENT_CODE = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.AUTO_PAY_MAX_WITHDRAWAL_LIMIT
  );
  useEffect(() => {
    store.getState().snackbar = true;
    //fetching the records
    fetchRecords();

    //source code list based on account
    accountId && autoPayServices.getSourceList(accountId)
      .then(sourceResponse => {
        setSourceList(sourceResponse?.data?.getSourceCdList["CM-ApaySrcLs"])
      })
      .catch(err => setSourceList([]))
  }, [accountId])

  useEffect(() => {
    if (store?.getState()?.labels) {
      adminService
        .getContentData(languageCode, "E_AUTOPAY")
        .then((res) => {
          setContent(res.data.getContents.E_AUTOPAY);
        })
        .catch(err => {
          setContent(null)
        })
    }
  }, [store?.getState()?.labels], languageCode);
  if (content) {
    content.forEach((element) => {
      if (element.contentCode === "E_AUTOPAY_WARNING_TITLE") {
        AUTO_PAYMENT_DELETE_WARNING_TEXT = element.answer;
      }
      if (element.contentCode === "E_AUTOPAY_EMPTY_RECORD_TITLE") {
        EMPTY_RECORD_LOG_MESSAGE = element.answer;
      }
      if (element.contentCode === "E_AUTOPAY_SUCCESS_MESSAGE") {
        AUTO_PAYMENT_SUCCESS_TEXT = element.answer;
      }
      if (element.contentCode === "E_AUTOPAY_STARTDATE_VALIDATION") {
        VALIDATION_CONTENTS.start_date = element.answer
      }
      if (element.contentCode === "E_AUTOPAY_ACCOUNT_VALIDATION") {
        VALIDATION_CONTENTS.account_number = element.answer
      }
      if (element.contentCode === "E_AUTOPAY_CARD_VALIDATION") {
        VALIDATION_CONTENTS.card_number = element.answer
      }
      if (element.contentCode === "E_AUTOPAY_EXPIREON_VALIDATION") {
        VALIDATION_CONTENTS.expires_on = element.answer
      }
      if (element.contentCode === "E_AUTOPAY_NAME_VALIDATION") {
        VALIDATION_CONTENTS.name = element.answer
      }
      if (element.contentCode === "E_AUTOPAY_MAX_LIMIT_VALIDATION") {
        VALIDATION_CONTENTS.limit = element.answer
      }
      if (element.contentCode === "E_AUTOPAY_SINGLE_RECORD_DELETE_TEXT"){
        AUTOPAY_SINGLE_RECORD_DELETE_TEXT = element.answer
      }

    });
  }
  useEffect(() => {
    dataLoading === "LOADING" ? setLoading(true) : setLoading(false)
  }, [dataLoading, showText])

  useEffect(() => {
    //If we are not entering all mandetory fields for New Record, then button should be disabled
    if (enteredData && (
      enteredData.startDate === "" || 
      enteredData.startDate === null || 
      enteredData.sourceCode === "" || 
      enteredData.externalAccountId === "" || 
      (enteredData.expireDate === "" && enteredData.autoPayMethod !== BANK_TEXT) || 
      enteredData.entityName === "" || 
      (enteredData.autopayMaxWithdrawalAmount && MAX_LIMIT_TENENT_CODE && parseFloat(enteredData.autopayMaxWithdrawalAmount) > MAX_LIMIT_TENENT_CODE))) 
    {
      setDisable(true)
    }
    //If there are no changes entered for existing record, then also button should be disabled
    else if (enteredData === undefined) {
      setDisable(true)
    }
    //In else conditions, button should be ENABLED.
    else {
      setDisable(false)
    }
  }, [disable, enteredData])

  const clickOnSave = () => {
    if (isNew) {
      if(enteredData.endDate===null){
        enteredData.endDate=''
      }
      setDataLoading("LOADING")
      accountId && autoPayServices.createAndSaveNewRecord(accountId, enteredData)
        .then((response) => {
          response?.data?.createAutoPay?.accountAutopayId &&  fetchRecords()
          setDataLoading("")
          setIsError(response.data.createAutoPay.isError)
          setShowText(response.data.createAutoPay.errorInformation)
          response?.data?.createAutoPay?.accountAutopayId && setIsNew(false)
          setEnteredData()
          timeOutFunction()
        })
        .catch(error => {
          setDataLoading("")
          setIsError("true")
          setShowText(error.networkError.result.errors[0].message);
        })
    }
    else {
      setDisable(true)
      setDataLoading("LOADING")
      accountId && autoPayServices.updateAutoPayRecords(accountId, enteredData)
        .then((response) => {
          fetchRecords()
          setDataLoading("")
          setIsError(null)
          setIsNew(false)
          setEnteredData()
          timeOutFunction()
        })
        .catch(error => {
          setDataLoading("")
          setIsError("true")
          setShowText(error.networkError.result.errors[0].message);
        })
    }

  }

  useEffect(() => {
    onReset && setAutoPayData(initialData)
    setOnReset(false)
    setDisable(true)
  }, [onReset])

  //reset the record 
  const clickOnReset = () => {
    let initialAutoPayData = [...initialData]
    initialAutoPayData && initialAutoPayData.map((eachList, index) => {
      initialAutoPayData[index] = { ...eachList, reset: true }
    })
    setInitialData(initialAutoPayData)
    setIsNew(false)
    setOnReset(true)
    setShowText()
  }

  const [loader,setLoader]=useState(false)
  const fetchRecords = () => {
    setDisable(true)
    setLoader(true)
    accountId && autoPayServices.getAutoPayRecords(accountId).then((response) => {
      setLoader(false)
      response.data.getAutoPayData.autopayDetails === null && (store.getState().snackbar = false);
      let autoPayResponse = response.data?.getAutoPayData?.autopayDetails
      autoPayResponse = (Array.isArray(autoPayResponse)) ? [...response.data.getAutoPayData.autopayDetails] : (autoPayResponse === null) ? [] : [response.data.getAutoPayData.autopayDetails]
      autoPayResponse && setInitialData(autoPayResponse)
      autoPayResponse && setAutoPayData(autoPayResponse)
    })
    .catch(err => {
      setLoader(false)
      setInitialData([]);
      setAutoPayData([]);
    })
  }
  const timeOutFunction = () => {
    setTimeout(function () {
      setAlert(false)
      setIsError()
      setShowText()

    }, 20000)
  }

  useEffect(() => {
    (isError === null || isError === "true") ? setAlert(true) : setAlert(false)
  }, [showAlert, isError])

  //To Toggle the autopay feature
  const handlerOnClickAutoPay = () => {
    onClickAutoPay();
  }
  const clickOnNew = () => {
    setIsNew(true)
    setAutoPayData([...autoPayData, {...emptyRecord,uuid: uuid()}])
    setEnteredData()
  }
  //deleting the autopay records
  const delteRecordFromUI = (accountId, deleteId) => {

    store.getState().snackbar = true;
    if (deleteId.includes("-")) {
      fetchRecords()
    }
    else {
      accountId && deleteId && autoPayServices.deleteAutoPayRecord(accountId, deleteId)
        .then(response => {
          fetchRecords()
          store.getState().snackbar = false;
        })
        .catch(error => {
          setIsError("true")
          setShowText(error.networkError.result.errors[0].message);
        })
    }
    setIsNew(false)
    setEnteredData()
    timeOutFunction()
  }

  const onChangeEnteredRecord = (data) => {
    setEnteredData(data)
  }
  
  const handleRow = (id)  => (_,isExpanded) => {
    setRow(isExpanded ? id : null);  
  }

  const primaryLanguageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  const [paymentOptions, setPaymentOptions] = useState()
  useEffect(() => {
    if (primaryLanguageCode) {
      store.getState().snackbar = true;
      autoPayServices.getDropdownpData("E_AUTOPAY_PAYMENT_METHODS", primaryLanguageCode).then((resp) => {
          setPaymentOptions(resp?.data)
      })
    }
  }, []);

  useEffect(()=>{
    if(disable){
      localStorage.removeItem("enabled_state")
    }else{
      localStorage.setItem("enabled_state",1)
    }
  },[disable])

  const handleBeforeUnload=(e)=>{
    e.preventDefault()
    e.returnValue = '';
  }

  useEffect(()=>{
    if(disable){
      window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true});
    }
    else{
      window.addEventListener("beforeunload", handleBeforeUnload,{capture:true});  
    }
    return () => window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true})
  },[disable])

  return (
    <Grid container className={classes.mainGrid}>
      <Grid item container className={classes.heading} >
        <Grid item xs={6} sm={6} lg={8} >
          <Typography
            variant="h6">
            {AutopayTab}
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={4}>
          <Grid spacing={1} className={classes.cancelIconStyling}>
            <CancelIcon onClick={handlerOnClickAutoPay} className={classes.curserStyling}/>
          </Grid>
        </Grid>
      </Grid>
      <Grid 
        item 
        className={classes.contentGrid}
        style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
      >
      <Hidden mdDown>
        
        { loader ? (
            <><Grid item xs={12} md={12} lg={12} 
            align="center" 
            className={classes.loadingButton}
            >
                        <CircularProgress size={30} />
                      </Grid></>
        ) :
          (autoPayData && autoPayData.length === 0) && (
            <Grid container justify="space-between" direction="column">
              <Grid container justify="center">
                <Grid item md={9} lg={9} className={classes.emptyLogTextMedium}>
                  {
                    (autoPayData && autoPayData.length === 0) && <b>{EMPTY_RECORD_LOG_MESSAGE && EMPTY_RECORD_LOG_MESSAGE}</b>
                  }
                </Grid>
                <Grid item md={3} lg={3}>
                  <Grid container direction="row" justifyContent="flex-end" justify="flex-end">
                    <Grid item>
                      {
                        (autoPayData && autoPayData.length === 0) && <Button size="small" variant="outlined" className={classes.newButtonStyle} onClick={clickOnNew}>{labels?.E_AUTOPAY_NEW_BUTTON_TITLE}</Button>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )
        }
        
        <Grid container className={classes.accordionContainerStyling}>
          {(autoPayData && autoPayData.length > 0) && autoPayData.map((eachRecord, index) => {
            return (<AutoPayAccordionComponent
            isInError={isError}
              recordsLenght={autoPayData.length}
              key={eachRecord && eachRecord.accountAutopayId}
              id_num={index}
              info={eachRecord}
              delteRecordFromUI={delteRecordFromUI}
              onChangeEnteredRecord={onChangeEnteredRecord}
              labels={labels} 
              accountId={accountId}
              clickOnPlusButton={clickOnNew}
              sourceCodeList={sourceList}
              BANK_TEXT={BANK_TEXT}
              CREDIT_CARD_TEXT={CREDIT_CARD_TEXT}
              DEBIT_CARD_TEXT={DEBIT_CARD_TEXT}
              VALIDATION_CONTENTS={VALIDATION_CONTENTS}
              paymentOptions={paymentOptions}
              AUTOPAY_SINGLE_RECORD_DELETE_TEXT={AUTOPAY_SINGLE_RECORD_DELETE_TEXT}
              AUTO_PAYMENT_DELETE_WARNING_TEXT={AUTO_PAYMENT_DELETE_WARNING_TEXT}
              onChange={eachRecord.accountAutopayId ? (handleRow(eachRecord.accountAutopayId)) : (handleRow(eachRecord.uuid))}
              expanded={eachRecord.accountAutopayId ? (row === eachRecord.accountAutopayId) : (row === eachRecord.uuid)}
            />)
          })}
        </Grid>
        {
          (isError === null && showAlert === true) ? (

            <Grid item className={classes.successMsgStyling}>
              <Alert className={classes.greenColorAlert} severity="success">
                {AUTO_PAYMENT_SUCCESS_TEXT && AUTO_PAYMENT_SUCCESS_TEXT}
              </Alert>
            </Grid>
          ) : (isError === "true" && showAlert === true && showText && (<Grid item className={classes.successMsgStyling}>
            <Alert className={classes.redColorAlert} severity="error">
              {showText}          
            </Alert>
          </Grid>)
          )
        }

        <Grid container justify="center" className={classes.footerButtonContainer}>
          {autoPayData && autoPayData.length !== 0 && <>
            <Grid item>
              <Button disabled={disable} variant="outlined" onClick={clickOnSave} className={!disable ? customStyles.saveButtonStyling : customStyles.disabledSaveButton} >
                {labels?.E_AUTOPAY_SAVE_BUTTON_TITLE}
                {loading && <CircularProgress size={15} className={classes.circulorProgressStyling} />}
              </Button>
            </Grid>
            <Grid item>
              <Button disabled={(enteredData || isNew) ? false : true} onClick={clickOnReset} className={classes.cancelButtonStyling}>{labels?.E_AUTOPAY_CANCEL_BUTTON_TITLE}</Button>
            </Grid>

          </>}
        </Grid>
      </Hidden>
      <Hidden lgUp>
        {loader ? (
            <><Grid item xs={12} md={12} lg={12} 
            align="center" 
            className={classes.loadingButton}
            >
                        <CircularProgress size={30} />
                      </Grid></>
        ) : (
          <>
          <Grid container >
          <Grid container justify="space-between" direction="row" >
            <Box component={Grid} item sm={8} md={8} xs={8} className={classes.emptyLogText} >
              {
                (autoPayData && autoPayData.length === 0) && EMPTY_RECORD_LOG_MESSAGE
              }
            </Box>
            <Grid item sm={3} xs={3} md={3}>
              <Grid container direction="row" justifyContent="flex-end" justify="flex-end">
                <Grid item>
                  {
                    (autoPayData && autoPayData.length === 0) && <Button variant="outlined" className={classes.newButtonStyle} onClick={clickOnNew}>{labels?.E_AUTOPAY_NEW_BUTTON_TITLE}</Button>
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
        <Grid container className={classes.mobileAccordionContainerStyling}>
          {(autoPayData && autoPayData.length > 0) && autoPayData.map((eachRecord, index) => {
            return (<AutoPayAccordionComponent
              recordsLenght={autoPayData.length}
              key={eachRecord && eachRecord.accountAutopayId}
              id_num={index}
              info={eachRecord}
              delteRecordFromUI={delteRecordFromUI}
              onChangeEnteredRecord={onChangeEnteredRecord}
              accountId={accountId}
              clickOnPlusButton={clickOnNew}
              sourceCodeList={sourceList}
              labels={labels}
              BANK_TEXT={BANK_TEXT}
              paymentOptions={paymentOptions}
              CREDIT_CARD_TEXT={CREDIT_CARD_TEXT}
              DEBIT_CARD_TEXT={DEBIT_CARD_TEXT}
              VALIDATION_CONTENTS={VALIDATION_CONTENTS}
              AUTO_PAYMENT_DELETE_WARNING_TEXT={AUTO_PAYMENT_DELETE_WARNING_TEXT}
              AUTOPAY_SINGLE_RECORD_DELETE_TEXT={AUTOPAY_SINGLE_RECORD_DELETE_TEXT}
              onChange={eachRecord.accountAutopayId ? (handleRow(eachRecord.accountAutopayId)) : (handleRow(eachRecord.uuid))}
              expanded={eachRecord.accountAutopayId ? (row === eachRecord.accountAutopayId) : (row === eachRecord.uuid)}
            />)
          })}
        </Grid>
        {
          (isError === null && showAlert === true) ? (

            <Grid item className={classes.successMsgStyling}>
              <Alert className={classes.greenColorAlert} severity="success">
                {AUTO_PAYMENT_SUCCESS_TEXT && AUTO_PAYMENT_SUCCESS_TEXT}
              </Alert>
            </Grid>
          ) : (isError === "true" && showAlert === true && showText && (<Grid item className={classes.successMsgStyling}>
            <Alert className={classes.redColorAlert} severity="error">
              {showText}
            </Alert>
          </Grid>)
          )
        }
        <Grid container justify="center" className={classes.footerButtonContainer}>
          {autoPayData && autoPayData.length !== 0 && <>
            <Grid item>
              <Button disabled={disable} variant="outlined" onClick={clickOnSave} className={!disable ? customStyles.saveButtonStyling : customStyles.disabledSaveButton} >
                {labels?.E_AUTOPAY_SAVE_BUTTON_TITLE}
                {loading && <CircularProgress size={15} />}
              </Button>
            </Grid>
            <Grid item>
              <Button disabled={(enteredData || isNew) ? false : true} onClick={clickOnReset} className={classes.cancelButtonStyling}>{labels?.E_AUTOPAY_CANCEL_BUTTON_TITLE}</Button>
            </Grid>

          </>}
        </Grid>
          </>
        )}
        
      </Hidden>
      </Grid>
    </Grid>
  );
}
